import { Variants } from '@amplitude/experiment-js-client';

import { Values } from 'components/commonTypes';

import {
  EstimateAmplitudeFlagKeys,
  EstimateAmplitudeFlagType,
  TruthyValuesForEstimateFlagKeys,
} from './estimateAmplitudeFlags';

export const AmplitudeFlagKeys = {
  ...EstimateAmplitudeFlagKeys,
  fullCalendar: 'full-calendar-on-web',
  flatRateBanner: 'test-exp',
  servicePlanTabOnCustomerPage: 'service-plan-tab-on-customer-page',
  createServicePlanFromJob: 'create-service-plan-from-job',
  q1ServicePlanSmallWins: 'q1-service-plan-small-wins',
  mergeCustomersWithServicePlans: 'merge-customers-with-service-plans',
  improvedCardOnFileServicePlans: 'improved-card-on-file-service-plans',
  servicePlansVisitsTable: 'service-plans-visits-table',
  servicePlansPaymentsTable: 'service-plans-payments-table',
  profitRhinoContentUpdates: 'profit-rhino-content-updates',
  h20NewPriceBookSettings: 'hcp-2-0-price-book-settings',
  visualPricebook: 'visual-price-book',
  reportingVoice: 'reporting-voice',
  reportingServicePlans: 'reporting-service-plans',
  jobLineItemDetailsSettings: 'job-line-item-details-settings',
  improvedCardOnFile: 'improved-card-on-file',
  passwordBanner: 'password-banner',
  productTour: 'interactive-product-tour-mvp',
  homePageEmployeeStatus: 'homepage-employee-status',
  addFundsDialogDefault: 'add-funds-dialog',
  onMyWayTechPhotos: 'on-my-way-tech-photos',
  payrollAdmin: 'payroll-admin',
  pipelineCustomColumns: 'pipeline-custom-columns',
  pipelineMoveCustomColumns: 'pipeline-move-custom-columns',
  jobsFranchiseReporting: 'jobs-franchise-reporting',
  addServicePlansOnJobPage: 'add-service-plans-on-job-page',
  attachmentsOnLeads: 'attachments-leads-creation',
  calendarAppointments: 'calendar-appointments',
  RDCOnboarding: 'rdc-onboarding',
  mobileCheckDepositBetaPros: 'mobile-check-deposit-beta-pros',
  expenseCardsTransactionsTableV2: 'expense-card-transactions-table-v2',
  midSizeProSplashNavigation: 'mid-size-pro-splash-navigation',
  expenseCardsNotificationSettings: 'expense-cards-notification-settings',
  quickbooksOnlineIncomeAccountMapping: 'quickbooks-online-income-account-mapping',
  billPayAlpha: 'bill-pay-alpha',
  jobInputsWeb: 'job-inputs-web',
  expenseCardsRewardsTest: 'expense-cards-rewards-test',
  expenseCardsInstantFunding: 'expense-cards-instant-funding',
  newOnlineBooking: 'new-online-booking',
  newOnlineBookingWizard: 'new-online-booking-wizard',
  bookingDurationToggleInLaborRates: 'booking-duration-toggle-in-labor-rates',
  ExpenseCardsAcceleratedAchIbt: 'expense-cards-accelerated-ach-ibt',
  newInvoicesArch: 'new-invoices-arch',
  conquer: 'conquer',
  proCanRequestCardOnFileWeb: 'pro-can-request-card-on-file-web',
  royaltyReporting: 'royalty-reporting',
  enableConnectBankRequirement: 'enable-connect-bank-requirement',
  HCPMoney: 'hcp-money',
  hideAdditionalEmployeesFromUpsellFeatures: 'hide-additional-employees-from-upsell-features',
  voiceCallLogV2: 'voice-call-logs-v2',
  callQueues: 'call-queues',
  voiceAgentStatus: 'voice-agent-status',
  servicePlanSoldBy: 'service-plan-sold-by',
  tradeAcademyAppCard: 'trade-academy-app-card',
  dispatchAppCard: 'dispatch-app-card',
  contextualReporting: 'contextual-reporting',
  chargeCards: 'b2b_financing_charge_card',
  paymentsEnableCardReaderOrdering: 'payments-enable-card-reader-ordering',
  extendingIndefiniteServicePlans: 'extending-indefinite-service-plans',
  dataImportPriceBookSelfServe: 'data-import-price-book-self-serve',
  settingsWithLeftRail: 'settings-with-left-rail',
  jobMaterialDetails: 'job-material-details',
  customJobSignatures: 'custom-job-signatures',
  hcpAssistPlanUsageReportPage: 'hcpa-plan-usage-report-page',
  hcpAssistPlanUsageReportROI: 'hcpa-plan-usage-report-roi',
  paymentsCardOnFileRequestSms: 'payments-card-on-file-request-sms',
  consumerFinancing: 'cf_consumer_financing',
  scheduleAndShareReporting: 'schedule-and-share-reporting',
  customReportingTransition: 'custom-reporting-transition',
  pipelinePermissions: 'pipeline-permissions',
  pipelineStorylaneButton: 'pipeline-storylane-button',
  pipelineAppointments: 'pipeline-appointments',
  employeeLaborCostsSettings: 'employee-labor-costs-settings',
  copyJobV2: 'copy-job-v2',
  frequentlyUsedPricebookItems: 'frequently-used-pricebook-items',
  editMultipleLineItemsModal: 'edit-multiple-line-items-modal',
  disableBillPayExternalResources: 'disable-bill-pay-external-resources',
  expectedCostsSettings: 'expected-costs-settings',
  dataTransferMultipleInvoices: 'data-transfer-multiple-invoices',
  serviceAgreementsBusinessUnit: 'service-agreements-business-unit',
  billingNewPayWallPlanSummary: 'billing-new-plan-summary',
  billingPayWallPlanSummaryPriceDisplayCadence: 'paywall-plan-summary-price-display-cadence',
  voiceWarmTransferV2: 'voice-warm-transfer-v2',
  expenseCardsOnboardingWizard: 'expense-cards-onboarding-wizard',
  expenseCardsEnrollmentPage: 'expense-cards-enrollment-page',
  expenseCardsReceiptCapture: 'expense-cards-receipt-capture',
  billingEnableTransitionToHCPLiteButton: 'billing-enable-transition-to-hcp-lite-button',
  profitRhinoContentUpdateByVersions: 'profit-rhino-content-update-by-versions',
  payrollOnboardingWaitScreenMay23: 'payroll_onboarding_wait_screen_may23',
  reportingDateRange: 'reporting-date-range',
  paidInFullReporting: 'paid-in-full-reporting',
  getStartedEngagement: 'get-started-engagement',
  marketing: 'marketing',
  payrollDemoWaitlist: 'payroll-waitlist',
  payrollDemoWaitlistJoined: 'payroll-waitlist-joined',
  payrollLandingPageVideo: 'payroll-lp-image-vs-video',
  customersDeletedList: 'customers-deleted-list',
  paymentsDialogUiUpdate: 'payments-dialog-ui-update',
  billPayVendorAddressAutocomplete: 'bill-pay-vendor-address-autocomplete',
  hcpAssistImpersonationInvalidation: 'hcp-assist-impersonation-invalidation',
  cardReaderApiV4: 'card_reader_api_v4',
  jobContainerTreatment: 'job-container-treatment',
  billingEnabledDelayedRetry: 'billing-enable-delayed-retry',
  consumerFinancingOpportunitiesTableV1: 'cf-opportunities-table-v1',
  createJobWithCommission: 'create-job-with-commissions',
  payrollNewAddEditEmployee: 'payroll-new-add-edit-employee',
  billingEnableCreditCardsUUIDs: 'billing-enable-cc-api-uuids',
  paymentsCustomerBatchProfileAlphaCoreJobsCreditCardCharges:
    'payments-customer-batch-profile-alpha-core-jobs-credit-card-charges',
  paymentsOnboadingImprovements: 'payments-onboarding-improvements',
  functionalCustomerActions: 'functional-customer-actions',
} as const;

export type AmplitudeFlagType = Values<typeof AmplitudeFlagKeys>;

export const TruthyValuesForFlagKeys: Record<AmplitudeFlagType | EstimateAmplitudeFlagType, string> = {
  ...TruthyValuesForEstimateFlagKeys,
  [AmplitudeFlagKeys.voiceCallLogV2]: 'using-voice-call-logs-v2',
  [AmplitudeFlagKeys.callQueues]: 'using-call-queues',
  [AmplitudeFlagKeys.voiceAgentStatus]: 'using-voice-agent-status',
  [AmplitudeFlagKeys.voiceWarmTransferV2]: 'using-voice-warm-transfer-v2',
  [AmplitudeFlagKeys.fullCalendar]: 'using-full-calendar',
  [AmplitudeFlagKeys.flatRateBanner]: 'treatment',
  [AmplitudeFlagKeys.servicePlanTabOnCustomerPage]: 'using-service-plan-tab',
  [AmplitudeFlagKeys.createServicePlanFromJob]: 'using-create-service-plan-from-job',
  [AmplitudeFlagKeys.q1ServicePlanSmallWins]: 'using-q1-service-plan-small-wins',
  [AmplitudeFlagKeys.mergeCustomersWithServicePlans]: 'using-merge-customers-with-service-plans',
  [AmplitudeFlagKeys.improvedCardOnFileServicePlans]: 'using-improved-card-on-file-service-plans',
  [AmplitudeFlagKeys.servicePlansVisitsTable]: 'using-service-plans-visits-table',
  [AmplitudeFlagKeys.servicePlansPaymentsTable]: 'using-service-plans-payments-table',
  [AmplitudeFlagKeys.profitRhinoContentUpdates]: 'on',
  [AmplitudeFlagKeys.h20NewPriceBookSettings]: 'using-hcp-2-0-price-book-settings',
  [AmplitudeFlagKeys.visualPricebook]: 'using-visual-price-book',
  [AmplitudeFlagKeys.onMyWayTechPhotos]: 'using-on-my-way-tech-photos',
  [AmplitudeFlagKeys.improvedCardOnFile]: 'using-improved-card-on-file',
  [AmplitudeFlagKeys.reportingVoice]: 'reporting-voice-active',
  [AmplitudeFlagKeys.reportingServicePlans]: 'reporting-service-plans-active',
  [AmplitudeFlagKeys.jobLineItemDetailsSettings]: 'job-line-item-details-settings-active',
  [AmplitudeFlagKeys.passwordBanner]: 'using-password-banner',
  [AmplitudeFlagKeys.productTour]: 'using-interactive-product-tour-mvp',
  [AmplitudeFlagKeys.addFundsDialogDefault]: 'treatment',
  [AmplitudeFlagKeys.payrollAdmin]: 'using-payroll-admin',
  [AmplitudeFlagKeys.jobsFranchiseReporting]: 'using-jobs-franchise-reporting',
  [AmplitudeFlagKeys.pipelineCustomColumns]: 'using-pipeline-custom-columns',
  [AmplitudeFlagKeys.pipelineMoveCustomColumns]: 'using-pipeline-move-custom-columns',
  [AmplitudeFlagKeys.addServicePlansOnJobPage]: 'add-service-plans-on-jobs',
  [AmplitudeFlagKeys.attachmentsOnLeads]: 'using-attachments-on-leads-creation',
  [AmplitudeFlagKeys.calendarAppointments]: 'using-appointments',
  [AmplitudeFlagKeys.RDCOnboarding]: 'using-rdc-onboarding',
  [AmplitudeFlagKeys.mobileCheckDepositBetaPros]: 'using-mobile-check-deposit',
  [AmplitudeFlagKeys.homePageEmployeeStatus]: 'using-homepage-employee-status',
  [AmplitudeFlagKeys.expenseCardsTransactionsTableV2]: 'using-expense-card-transactions-table-v2',
  [AmplitudeFlagKeys.midSizeProSplashNavigation]: 'using-mid-size-pro-splash-navigation',
  [AmplitudeFlagKeys.expenseCardsNotificationSettings]: 'treatment',
  [AmplitudeFlagKeys.quickbooksOnlineIncomeAccountMapping]: 'using-quickbooks-online-income-account-mapping',
  [AmplitudeFlagKeys.billPayAlpha]: 'using-bill-pay-alpha',
  [AmplitudeFlagKeys.jobInputsWeb]: 'using-job-inputs-web',
  [AmplitudeFlagKeys.expenseCardsRewardsTest]: '',
  [AmplitudeFlagKeys.expenseCardsInstantFunding]: 'using-expense-cards-instant-funding',
  [AmplitudeFlagKeys.newOnlineBooking]: 'using-new-online-booking',
  [AmplitudeFlagKeys.newOnlineBookingWizard]: 'using-new-online-booking-wizard',
  [AmplitudeFlagKeys.bookingDurationToggleInLaborRates]: 'using-booking-duration-toggle-in-labor-rates',
  [AmplitudeFlagKeys.ExpenseCardsAcceleratedAchIbt]: 'using-expense-cards-accelerated-ach-ibt',
  [AmplitudeFlagKeys.newInvoicesArch]: 'using-new-invoices-arch',
  [AmplitudeFlagKeys.conquer]: 'using-conquer',
  [AmplitudeFlagKeys.proCanRequestCardOnFileWeb]: 'using-pro-can-request-card-on-file-web',
  [AmplitudeFlagKeys.royaltyReporting]: 'using-royalty-reporting',
  [AmplitudeFlagKeys.enableConnectBankRequirement]: 'using-enable-connect-bank-requirement',
  [AmplitudeFlagKeys.HCPMoney]: 'using-hcp-money',
  [AmplitudeFlagKeys.hideAdditionalEmployeesFromUpsellFeatures]: 'using-hide-additional-employees-from-upsell-features',
  [AmplitudeFlagKeys.servicePlanSoldBy]: 'using-service-plan-sold-by',
  [AmplitudeFlagKeys.tradeAcademyAppCard]: 'show',
  [AmplitudeFlagKeys.dispatchAppCard]: 'show',
  [AmplitudeFlagKeys.contextualReporting]: 'using-contextual-reporting',
  [AmplitudeFlagKeys.chargeCards]: 'using-b2b-financing-charge-card',
  [AmplitudeFlagKeys.paymentsEnableCardReaderOrdering]: 'using-payments-enable-card-reader-ordering',
  [AmplitudeFlagKeys.extendingIndefiniteServicePlans]: 'using-extending-indefinite-service-plans',
  [AmplitudeFlagKeys.dataImportPriceBookSelfServe]: 'using-data-import-price-book-self-serve',
  [AmplitudeFlagKeys.settingsWithLeftRail]: 'using-settings-with-left-rail',
  [AmplitudeFlagKeys.jobMaterialDetails]: 'using-job-material-details',
  [AmplitudeFlagKeys.customJobSignatures]: 'using-custom-job-signatures',
  [AmplitudeFlagKeys.hcpAssistPlanUsageReportPage]: 'using-hcpa-plan-usage-report-page',
  [AmplitudeFlagKeys.hcpAssistPlanUsageReportROI]: 'using-hcpa-plan-usage-report-roi',
  [AmplitudeFlagKeys.paymentsCardOnFileRequestSms]: 'using-payments-card-on-file-request-sms',
  [AmplitudeFlagKeys.consumerFinancing]: 'using-cf-consumer-financing',
  [AmplitudeFlagKeys.scheduleAndShareReporting]: 'using-schedule-and-share-reporting',
  [AmplitudeFlagKeys.customReportingTransition]: 'using-custom-reporting-transition',
  [AmplitudeFlagKeys.pipelinePermissions]: 'using-pipeline-permissions',
  [AmplitudeFlagKeys.pipelineStorylaneButton]: 'using-pipeline-storylane-button',
  [AmplitudeFlagKeys.pipelineAppointments]: 'using-pipeline-appointments',
  [AmplitudeFlagKeys.employeeLaborCostsSettings]: 'using-employee-labor-costs-settings',
  [AmplitudeFlagKeys.disableBillPayExternalResources]: 'disable-bill-pay-external-resources',
  [AmplitudeFlagKeys.expectedCostsSettings]: 'using-expected-costs-settings',
  [AmplitudeFlagKeys.copyJobV2]: 'using-copy-job-v2',
  [AmplitudeFlagKeys.frequentlyUsedPricebookItems]: 'using-frequently-used-pricebook-items',
  [AmplitudeFlagKeys.editMultipleLineItemsModal]: 'using-edit-multiple-line-items-modal',
  [AmplitudeFlagKeys.dataTransferMultipleInvoices]: 'using-data-transfer-multiple-invoices',
  [AmplitudeFlagKeys.serviceAgreementsBusinessUnit]: 'using-service-agreements-business-unit',
  [AmplitudeFlagKeys.billingNewPayWallPlanSummary]: 'use-new-paywall-plan-summary',
  [AmplitudeFlagKeys.billingPayWallPlanSummaryPriceDisplayCadence]: 'per-year',
  [AmplitudeFlagKeys.expenseCardsOnboardingWizard]: 'using-expense-cards-onboarding-wizard',
  [AmplitudeFlagKeys.expenseCardsEnrollmentPage]: 'using-expense-cards-enrollment-page',
  [AmplitudeFlagKeys.expenseCardsReceiptCapture]: 'using-expense-cards-receipt-capture',
  [AmplitudeFlagKeys.billingEnableTransitionToHCPLiteButton]: 'use-transition-to-hcp-lite-button',
  [AmplitudeFlagKeys.profitRhinoContentUpdateByVersions]: '',
  [AmplitudeFlagKeys.payrollOnboardingWaitScreenMay23]: 'using-wait-screen',
  [AmplitudeFlagKeys.reportingDateRange]: 'using-reporting-date-range',
  [AmplitudeFlagKeys.paidInFullReporting]: 'using-paid-in-full-reporting',
  [AmplitudeFlagKeys.getStartedEngagement]: 'using-get-started-engagement',
  [AmplitudeFlagKeys.marketing]: 'using-marketing',
  [AmplitudeFlagKeys.payrollDemoWaitlist]: 'using-payroll-waitlist',
  [AmplitudeFlagKeys.payrollDemoWaitlistJoined]: 'using-payroll-waitlist-joined',
  [AmplitudeFlagKeys.payrollLandingPageVideo]: 'using-payroll-lp-video',
  [AmplitudeFlagKeys.customersDeletedList]: 'using-customers-deleted-list',
  [AmplitudeFlagKeys.paymentsDialogUiUpdate]: 'using-payments-dialog-ui-update',
  [AmplitudeFlagKeys.billPayVendorAddressAutocomplete]: 'using-vendor-address-autocomplete',
  [AmplitudeFlagKeys.hcpAssistImpersonationInvalidation]: 'using-hcp-assist-impersonation-invalidation',
  [AmplitudeFlagKeys.cardReaderApiV4]: 'using-card-reader-api-v4',
  [AmplitudeFlagKeys.jobContainerTreatment]: 'using-job-container-treatment',
  [AmplitudeFlagKeys.billingEnabledDelayedRetry]: 'use-enable-delayed-retry',
  [AmplitudeFlagKeys.consumerFinancingOpportunitiesTableV1]: 'using-cf-opportunities-table-v1',
  [AmplitudeFlagKeys.createJobWithCommission]: 'using-create-job-with-commissions',
  [AmplitudeFlagKeys.payrollNewAddEditEmployee]: 'using-new-add-edit-employee',
  [AmplitudeFlagKeys.billingEnableCreditCardsUUIDs]: 'use-enable-uuids-for-ccs',
  [AmplitudeFlagKeys.paymentsCustomerBatchProfileAlphaCoreJobsCreditCardCharges]:
    'using-payments-customer-batch-profile-alpha-core-jobs-credit-card-charges',
  [AmplitudeFlagKeys.paymentsOnboadingImprovements]: 'using-payments-onboarding-improvements',
  [AmplitudeFlagKeys.functionalCustomerActions]: 'using-functional-customer-actions',
} as const;

export const DefaultFlagValues: Variants = {} as const;
